import { render } from "./MolecularDiagnosticsReport.vue?vue&type=template&id=634760bc"
import script from "./MolecularDiagnosticsReport.vue?vue&type=script&lang=js"
export * from "./MolecularDiagnosticsReport.vue?vue&type=script&lang=js"

import "./MolecularDiagnosticsReport.vue?vue&type=style&index=0&id=634760bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__